import Config from '../config'
import { defineStore } from 'pinia'
import { FetchWrapper, Utils } from '@/lib'
import { QuestHelpers, TitleHelpers } from '@/lib'

export const useQuestStore = defineStore('questStore', {
    state: () => ({
        questsMap: {},
        sourceQuests: [],
        targetQuests: [],
    }),
    persist: false,
    actions: {
        flushQuests() {
            this.questsMap = {}
            this.sourceQuests = []
            this.targetQuests = []
        },

        hydrateQuests(quests = []) {
            var self = this
            let hydratedQuests = []
            for (var i = 0; i < quests.length; i++) {
                let quest = quests[i]
                let questId = quest.quest_id
                quest = Object.assign({}, QuestHelpers.createEmptyQuest(), quests[i])
                quest.quest_name = QuestHelpers.getTitleForQuest(quest)
                quest.source_title_name = TitleHelpers.getTitleName(quest.title_id)
                quest.target_title_name = TitleHelpers.getTitleName(quest.target_title_id)
                self.questsMap[questId] = quest
                hydratedQuests.push(quest)
            }
            return hydratedQuests
        },

        async getQuests(endpoint, component) {
            return await FetchWrapper.get(`${Config.BASE_URL}/${endpoint}`)
            .then((quests) => {
                if (!quests) {
                    quests = []
                }
                return quests
            }).catch((error) => {
                Utils.notifyError(component, error)
                return Promise.reject(error)
            })
        },

        async getSourceQuests(component, force = false) {
            if (this.sourceQuests && this.sourceQuests.length && !force) {
                this.sourceQuests = this.hydrateQuests(this.sourceQuests)
                return this.sourceQuests
            }
            let sourceQuests = await this.getQuests('quests', component, force);
            this.sourceQuests = this.hydrateQuests(sourceQuests)
            return this.sourceQuests
        },

        async getTargetQuests(component, force = false) {
            if (this.targetQuests && this.targetQuests.length && !force) {
                this.targetQuests = this.hydrateQuests(this.targetQuests)
                return this.targetQuests
            }
            let targetQuests = await this.getQuests('target-quests', component, force);
            this.targetQuests = this.hydrateQuests(targetQuests)
            return this.targetQuests
        },

        async getQuestByIdAsync(component, questId) {
            const self = this
            return await FetchWrapper.get(`${Config.BASE_URL}/quest/${questId}`)
            .then((quest) => {
                self.updateQuestByIdSync(questId, quest)
                return quest
            }).catch((error) => {
                Utils.notifyError(component, error)
                return Promise.reject(error)
            })
        },

        // Update cache
        updateQuestByIdSync(questId, questUpdate) {
            for (let i = 0; i < this.sourceQuests.length; i++) {
                let quest = this.sourceQuests[i]
                if (quest.quest_id == questId) {
                    this.sourceQuests[i] = {...quest, ...questUpdate}
                    this.questsMap[questId] = questUpdate
                    break;
                }
            }
            for (let i = 0; i < this.targetQuests.length; i++) {
                let quest = this.targetQuests[i]
                if (quest.quest_id == questId) {
                    this.targetQuests[i] = {...quest, ...questUpdate}
                    this.questsMap[questId] = questUpdate
                    break;
                }
            }
        },
    }
})
